import { render, staticRenderFns } from "./WOInfoIncidentTypeCard.vue?vue&type=template&id=1b62099a&"
import script from "./WOInfoIncidentTypeCard.vue?vue&type=script&lang=js&"
export * from "./WOInfoIncidentTypeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports